import { verifyOtp } from "../../../actions/login/verifyOtp";
import showToaster from "../../../helpers/toastrMessgaes/showToaster";

async function submit(values, dispatch) {
    let phoneDialCode, phoneNumber, verificationCode, userType = 1, preferredLanguage;
    phoneDialCode = values?.phoneDialCode, phoneNumber = values?.phoneNumber, verificationCode = values?.verificationCode;
    preferredLanguage = values?.preferredLanguage;
    if (!values?.verificationCode || isNaN(values?.verificationCode) || values?.verificationCode?.length < 4) {
        await showToaster({ messageId: 'invalidOtp', toasterType: 'error' })
        return;
    }

    await dispatch(verifyOtp(phoneDialCode, phoneNumber, verificationCode, userType, preferredLanguage, values?.referUrl));
}

export default submit; 